import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrelineLoader } from '@core/components/PrelineLoader';
import { LanguageSwitcher } from '@features/auth/components/LanguageSwitcher';

/**
 * Auth Layout for login/authentication routes
 */
export function AuthLayout() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg-subtle)] p-4 sm:p-8">
      <PrelineLoader />
      <div className="grid w-full max-w-4xl overflow-hidden rounded-2xl border border-[var(--color-border)] bg-white shadow-sm md:grid-cols-[0.9fr_1.1fr]">
        <aside className="relative hidden min-h-[620px] overflow-hidden bg-[#184774] p-10 text-white md:flex md:flex-col md:justify-between">
          <div className="absolute -right-20 -top-20 size-64 rounded-full bg-[#4BDAC0]/15" />
          <div className="relative">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#4BDAC0]">Neovision Platform</p>
            <h1 className="mt-8 text-4xl font-bold leading-tight">{t('auth.layout.headline')}</h1>
            <p className="mt-5 max-w-sm text-sm leading-7 text-blue-100">
              {t('auth.layout.intro')}
            </p>
          </div>
          <div className="relative border-l-2 border-[#4BDAC0] pl-4 text-sm leading-6 text-blue-100">
            {t('auth.layout.footer')}
          </div>
        </aside>
        <main className="relative flex min-h-[560px] items-center p-7 sm:p-12">
          <LanguageSwitcher className="absolute right-4 top-4 w-36" />
          <div className="mx-auto w-full max-w-sm"><Outlet /></div>
        </main>
      </div>
    </div>
  );
}
